export default {

    BATHTUB: {
        stepOne: {
            menu: {
                title: 'Sur mesure',
                body:  {
                    len: '2',
                    1:   'Taille de base:',
                    2:   'Taille effective:',
                },
            },
            form: {
                title:  'Taille effective',
                width:  'LARGEUR (CM)',
                length: 'LONGUEUR (CM)',
                to:     'à',
            },

        },
        stepTwo: {
            menu: {
                title: 'Rebords',
                body:  {
                    len:   '2',
                    1:     'Code de rebords',
                    2:     'Rebord partiel',
                    back:  "à l'arrière",
                    front: "à l'avant",
                    left:  "à gauche",
                    right: "à droite",
                },
            },
            form: {
                title:    'Code de rebords:',
                checkbox: 'Rebord partiel',
                back:  "à l'arrière",
                front: "à l'avant",
                left:  "à gauche",
                right: "à droite",
            },
            summary: {
                Z23: {
                    '1':  "Rebord à l'arrière",
                    '02': "Rebord partiel à l'arrière à gauche",
                    '03': "Rebord partiel à l'arrière à droite"
                },
                Z45: {
                    '1':  "Rebord à droite",
                    '04': "Rebord partiel à droite à l'arrière",
                    '05': "Rebord partiel à droite à l'avant"
                },
                Z67: {
                    '1':  "Rebord à l'avant",
                    '06': "Rebord partiel à l'avant à droite",
                    '07': "Rebord partiel à l'avant à gauche"
                },
                Z81: {
                    '1':  "Rebord à gauche",
                    '01': "Rebord partiel à gauche à l'arrière",
                    '08': "Rebord partiel à gauche à l'avant"
                }
            }

        },
        stepThree: {
            menu: {
                title: "Version d'angle",
                title2: "Version d'angle",
                body:  {
                    len: '1',
                    1:   'Angles configurées',
                    EA12: "À l'arrière à gauche",
                    EA34: "À l'arrière à droite",
                    EA78: "À l'avant à gauche",
                    EA56: "À l'avant à droite",
                },
            },
            form: {
                back_left:   "À l'arrière à gauche",
                back_right:  "À l'arrière à droite",
                front_left:  "À l'avant à gauche",
                front_right: "À l'avant à droite",
            },

        },
        stepFour: {
            menu: {
                title: 'Trous pour la robinetterie',
                body:  {
                    len: '1',
                    1:   'Trou pour mélangeur monotrou',
                    2:   "à l'avant à droite",
                    L1:  'Mélangeur monotrou',
                    L2:  'Perçage arrondi sur mesure',
                    AT:  'Perçage sur mesure',
                },
            },
            form: {
                armatur_type:          'Type de garniture',
                position:              'Position',
                checkbox:              'Rebord partiel',
                L1:                    'Mélangeur monotrou',
                L2:                    'Perçage arrondi sur mesure',
                AT:                    'Perçage sur mesure',
                L2M:                   'mm',
                armatur:               'Garniture d’écoulement',
                armatur_placeholder:   'Supplier and model',
                anmerkung:             'COMMENTAIRE',
                anmerkung_placeholder: 'Texte',
                drawing_upload:        'TÉLÉCHARGER DESSIN',
                drawing_necessary:     'Dessin obligatoire',
            },

        },
        stepFive: {
            menu: {
                title: 'Garniture',
                body:  {
                    len:  '1',
                    1:    'present',
                    SPV:  'SPLASH',
                    ALGV: '',
                },
            },
            form: {
                title:      'TRAITEMENT DE SURFACE',
                text_field: {
                    placeholder: 'Position placement special',
                },
                SPV:     'Garniture Schmidlin SPLASH',
                ALGV:    'Garniture d’écoulement',
                options: [
                    'Couleur',
                ],
                checkbox: {
                    label1: 'ANTIGLISS PRO',
                    label2: 'CLEANEFFECT',
                },
            },

        },
        stepSix: {
            menu: {
                title: 'Poignées',
                body:  {
                    len: '1',
                    1:   'Present',
                    GR:  'Poignée',
                },
            },
            form: {
                GR:         'Avec poignée(s)',
                text_field: {
                    placeholder: 'Remarques pour dessin spécial',
                },
            },

        },
        stepSeven: {
            menu: {
                title: 'Systèmes balnéo',
                body:  {
                    len:         '2',
                    whirlsystem: 'Systèmes balnéo',
                    TA:          'Indication de la température',
                    WM:          'Alarme aquatique',
                    FL2:         'Chromothérapie',
                    SW2:         'Projecteur subaquatique',
                    ALG:         'Garniture d’écoulement'
                },
            },
            form: {
                armatur:  'Fitting',
                option: 'OPTIONS',
                TA:     'Indication de la température',
                WM:     'Alarme aquatique',
                FL2:    'Chromothérapie',
                SW2:    'Projecteur subaquatique',
                system: 'Avec système whirl',
            },

        },
        stepEight: {
            menu: {
                title: 'Système audio',
                body:  {
                    len:         '1',
                    1:           'Système audio',
                    soundsystem: 'Schmidlin SOUNDBOX',
                },
            },
            form: {
                system: 'Avec système audio',
            },
        },

        stepNine: {
            menu: {
                title: 'Surface',
                title2: 'Couleur',
                body:  {
                    len:       '2',
                    1:         'blanc mat',
                    2:         'ANTIGLISS PRO, CLEANEFFECT',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'CLEANEFFECT',
                },
            },
            form: {
                ober:           'TRAITEMENT DE SURFACE',
                glazePlus:      'CLEANEFFECT',
                antiglissPro:   'ANTIGLISS PRO',
                txtPlaceholder: 'Remarque pour dessin spécial',
                colorName:      'Nom de la couleur',
                options:        [
                    'Nom de la couleur',
                ],
            },

        },


    },

    DWDF: {
        stepOne: {
            menu: {
                title: 'Sur mesure',
                body:  {
                    len: '2',
                    1:   'Taille de base:',
                    2:   'Taille effective:',
                },
            },
            form: {
                title:  'Taille de base',
                width:  'LARGEUR (CM)',
                length: 'LONGEUR (CM)',
                to:     'à',
            },

        },
        stepTwo: {
            menu: {
                title: 'Rebords',
                body:  {
                    len:   '2',
                    1:     'Rebords',
                    2:     'Rebord partiel',
                    back:  'à l\'arrière',
                    front: 'à l\'avant',
                    left:  'à gauche',
                    right: 'à droite',
                },
            },
            form: {
                title:    'Rebords',
                checkbox: 'Rebord partiel',
                back:  'à l\'arrière',
                front: 'à l\'avant',
                left:  'à gauche',
                right: 'à droite',
            },
            summary: {
                Z23: {
                    '1':  "Rebord à l'arrière",
                    '02': "Rebord partiel à l'arrière à gauche",
                    '03': "Rebord partiel à l'arrière à droite"
                },
                Z45: {
                    '1':  "Rebord à droite",
                    '04': "Rebord partiel à droite à l'arrière",
                    '05': "Rebord partiel à droite à l'avant"
                },
                Z67: {
                    '1':  "Rebord à l'avant",
                    '06': "Rebord partiel à l'avant à droite",
                    '07': "Rebord partiel à l'avant à gauche"
                },
                Z81: {
                    '1':  "Rebord à gauche",
                    '01': "Rebord partiel à gauche à l'arrière",
                    '08': "Rebord partiel à gauche à l'avant"
                }
            }

        },
        stepThree: {
            menu: {
                title: "Version d'angles",
                title2: "Version d'angles",
                body:  {
                    len: '1',
                    1:   'Angle(s) definé(s)',
                    EA12: "À l'arrière à gauche",
                    EA34: "À l'arrière à droite",
                    EA78: "À l'avant à gauche",
                    EA56: "À l'avant à droite",
                },
            },
            form: {
                back_left:   "À l'arrière à gauche",
                back_right:  "À l'arrière à droite",
                front_left:  "À l'avant à gauche",
                front_right: "À l'avant à droite",
            },

        },
        stepFour: {
            menu: {
                title: 'Tablier',
                sheight:  'Hauteur de tablier:',
                body:  {
                    len:   '1',
                    1:     'Perçage pour mélangeur monotrou',
                    back:  'à l\'arrière',
                    front: 'à l\'avant',
                    left:  'à gauche',
                    right: 'à droite',
                },
            },
            form: {
                title:    'Code de tabliers:',
                checkbox: 'Tablier raccourci',
                sheight:  'Hauteur de tablier (cm):',
                back:  'à l\'arrière',
                front: 'à l\'avant',
                left:  'à gauche',
                right: 'à droite',
            },
            summary: {
                S23: {
                    '1':  "Tablier à l'arrière",
                    '02': "Tablier raccourci à l'arrière à gauche",
                    '03': "Tablier raccourci à l'arrière à gauche"
                },
                S45: {
                    '1':  "Tablier à droite",
                    '04': "Tablier raccourci à droite à l'arrière",
                    '05': "Tablier raccourci à droite à l'avant"
                },
                S67: {
                    '1':  "Tablier à l'avant",
                    '06': "Tablier raccourci à l'avant à droite",
                    '07': "Tablier raccourci à l'avant à gauche"
                },
                S81: {
                    '1':  "Tablier à gauche",
                    '01': "Tablier raccourci à gauche à l'arrière",
                    '08': "Tablier raccourci à gauche à l'avant"
                }
            }
        },
        stepFive: {
            menu: {
                title: 'Surface',
                title2: 'Couleur',
                body:  {
                    len:       '2',
                    1:         'blanc mat',
                    2:         'ANTIGLISS PRO, CLEANEFFECT',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'CLEANEFFECT',
                    aquagrip:  'AQUAGRIP',
                    MISSING_GP: 'ANTIGLISS PRO',
                    OV:        'CLEANEFFECT',
                    MISSING_AG: 'AQUAGRIP',
                },
            },
            form: {
                ober:           'TRAITEMENT DE SURFACE',
                glazePlus:      'CLEANEFFECT',
                antiglissPro:   'ANTIGLISS PRO',
                aquagrip:       'AQUAGRIP',
                txtPlaceholder: 'Remarques pour dessin spécial',
                colorName:      'Nom de la couleur',
                options:        [
                    'Nom de la couleur',
                ],
            },
        },

    },
    WT: {
        stepOne: {
            menu: {
                title: 'Sur mesure',
                body:  {
                    len: '2',
                    1:   'Taille de base:',
                    2:   'Taille effective:',
                },
                left:  'Mesure axiale à gauche:',
                front: 'Mesure axiale à l\'avant:'
            },
            form: {
                title: 'Taille de base',
                tiefe: 'PROFONDEUR',
                width: 'LARGEUR',
                to:    'à',
                left:  'MSR AXIALE GAUCHE',
                front: 'MSR AXIALE AVANT'
            },

        },
        stepTwo: {
            menu: {
                title: 'Perçage sur mesure',
                body:  {
                    len:                      '2',
                    1:                        'Distributeur de savon,',
                    2:                        'Distributeur pour serviettes cosmétiques',
                    MISSING_WT_ALAZ_CHECKBOX: 'Trou pour la robinetterie',
                    MISSING_WT_ALAZ_checkbox: 'Trou pour la robinetterie',
                    MISSING_WT_ALS_CHECKBOX:  'Perçage sur mesure',
                    MISSING_WT_ALS_checkbox:  'Perçage sur mesure',
                    MISSING_SSPV_checkbox:    'Distributeur de savon',
                    SSPV:                     'Distributeur de savon',
                    ST:                       'Prise électrique',
                    HTH:                      'Porte-serviette',
                },
            },
            form: {
                armaturenloch:            'Trou pour la robinetterie',
                armatur:                  'Trou pour la robinetterie',
                MISSING_WT_ALAZ_CHECKBOX: 'Trou pour la robinetterie',
                MISSING_WT_ALAZ_checkbox: 'Trou pour la robinetterie',
                MISSING_WT_ALS_CHECKBOX:  'Percement de trou',
                MISSING_WT_ALS_checkbox:  'Percement de trou',
                MISSING_SSPV_checkbox:    'Distributeur de savon',
                SSPV:                     'Distributeur de savon',
                ST:                       'Prise électrique',
                HTH:                      'Porte-serviette',
                position:                 'Position du trou',
                specialHole:              'Percement trou spécial',
                loch3:                    '3-hole tap fitting',
                description:              'Description',
                drawing:                  'TÉLÉCHARGER DÉSSIN',
                soapDispenser:            'Percement trou spécial pour distributeur de savon',
                socket:                   'Percement trou spécial pour prise électrique',
                towerHolder:              'Percement trou spécial pour porte-serviette',
                left:                     'à gauche',
                S:                        'S',
                A:                        'A',
            },

        },
        stepThree: {
            menu: {
                title: 'Autres options',
                body:  {
                    len:  '2',
                    1:    'Distributeur pour serviettes cosmétiques',
                    2:    'Sans trop-plein',
                    UL:   'Sans trop-plein',
                    UL_inverter:   'Sans trop-plein',
                    KTSV: 'Distributeur pour serviettes cosmétiques',
                    MISSING_KTSV_checkbox: 'Distributeur pour serviettes cosmétiques',
                },
            },
            form: {
                tissueDispensers: 'Distributeur pour serviettes cosmétiques',
                UL:               'Sans trop-plein',
                KTSV:             'Distributeur pour serviettes cosmétiques',
                position:         'Position',
                withoutOverflow:  'Sans trop-plein',
                above_left:       "à l'arrière à gauche",
                above_right:      "à l'arrière à droite",
                bellow_left:      "à l'avant à gauche",
                bellow_right:     "à l'avant à droite",
                text_field: {
                    placeholder: 'Remarques pour dessin spécial',
                },
            },

        },
        stepFour: {
            menu: {
                title: 'Surface',
                title2: 'Couleur',
                body:  {
                    len:       '2',
                    1:         'blanc mat',
                    2:         'ANTIGLISS PRO, CLEANEFFECT',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'ANTIGLISS PRO',
                    OV:        'CLEANEFFECT',
                },
            },
            form: {
                ober:           'TRAITEMENT DE SURFACE',
                glazePlus:      'CLEANEFFECT',
                antiglissPro:   'ANTIGLISS PRO',
                txtPlaceholder: 'Remarques pour dessin spécial',
                colorName:      'Nom de la couleur',
                options:        [
                    'Nom de la couleur',
                ],
            },


        },
    },
    KRW: {
        stepOne: {
            menu: {
                title: 'Sur mesure',
                body:  {
                    len: '2',
                    1:   'Taille de base:',
                    2:   'Taille effective:',
                },
            },
            form: {
                title:  'Taille de base',
                width:  'LARGEUR (CM)',
                length: 'LONGEUR (CM)',
                to:     'à',
            },

        },
        stepTwo: {
            menu: {
                title: 'Rebords visibles',
                body:  {
                    len:   '2',
                    1:     'Rebords visibles',
                    back:  "en haut",
                    front: "en bas",
                    left:  'à gauche',
                    right: 'à droite',
                },
            },
            form: {
                title:    'Code de rebords:',
                left:     "À gauche",
                right:    "À droite",
                back:     "En haut",
                front:    "En bas",
            },
            summary: {
                SK23: {
                    '1':  " · rebords en haut"
                },
                SK45: {
                    '1':  " · rebords à droite"
                },
                SK67: {
                    '1':  " · rebords en bas"
                },
                SK81: {
                    '1':  " · rebords à gauche"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Prises',
                title2: 'Prises',
                type: 'Type de prise',
                socket: 'Prise',
                body:  {
                    ST1: 'Prise 1',
                    ST2: 'Prise 2',
                    ST3: 'Prise 3',
                    ST4: 'Prise 4',
                    ST5: 'Prise 5',
                },
            },
            form: {
                type: 'Type de prise',
                socket: 'Prise',
                position_x: 'Position horizontale (cm)',
                position_y: 'Position verticale (cm)',
            },

        },
        stepFour: {
            menu: {
                title: 'Découpes rectangulaires',
                body:  {
                    AS1: '(1)',
                    AS2: '(2)',
                    AS3: '(3)',
                    AS4: '(4)',
                    AS5: '(5)',
                },
                summary:  {
                    AS1: 'Découpe 1',
                    AS2: 'Découpe 2',
                    AS3: 'Découpe 3',
                    AS4: 'Découpe 4',
                    AS5: 'Découpe 5',
                },
            },
            form: {
                title: 'Découpe',
                position_x: 'Position horizontale (cm)',
                position_y: 'Position verticale (cm)',
                size_x: 'Mesure horizontale (cm)',
                size_y: 'Mesure verticale (cm)',
            },

        },
        stepFive: {
            menu: {
                title: 'Découpes rondes',
                body:  {
                    ASR1: '(1)',
                    ASR2: '(2)',
                    ASR3: '(3)',
                    ASR4: '(4)',
                    ASR5: '(5)',
                },
                summary:  {
                    ASR1: 'Découpe ronde 1',
                    ASR2: 'Découpe ronde 2',
                    ASR3: 'Découpe ronde 3',
                    ASR4: 'Découpe ronde 4',
                    ASR5: 'Découpe ronde 5',
                },
            },
            form: {
                title: 'Découpe',
                measure: 'Diamètre (cm)',
                position_x: 'Position horizontale (cm)',
                position_y: 'Position verticale (cm)'
            },

        },
        stepSix: {
            menu: {
                title: 'Rebords incurvé',
                body:  {
                    GK45: 'Rebords incurvé à droite',
                    GK81: 'Rebords incurvé à gauche',
                },
            },
            form: {
                measure: 'Mesure en (cm)',
                left: 'À gauche',
                right: 'À droite',
            },

        },
        stepSeven: {
            menu: {
                title: 'Surface',
                title2: 'Couleur',
                body:  {
                    len:  '2',
                    OV:  'CLEANEFFECT',
                },
            },
            form: {
                ober:           'TRAITEMENT DE SURFACE',
                glazePlus:      'CLEANEFFECT',
                txtPlaceholder: 'Remarques pour dessin spécial',
                colorName:      'Nom de la couleur',
                options:        [
                    'Nom de la couleur',
                ],
            },

        },
    },
    previous:           'AVANT',
    next:               'PLUS',
    downloadAndContact: {
        title:             'TÉLÉCHARGEMENTS ET CONTACT',
        configurationCode: 'Code de configuration:',
        schmidlinArtNo:    'No. d\'article:',
        SGNr:              'No. SGVSB:',
        stNr:              'No. ST:',
        recommended:       'Recommendé',
        salesPrice:        'Prix brut',
        totalPrice:        'Totale',
        inquireQuotation:  'RÉSUMÉ',
        order:             'COMMANDER',
        contactDealer:     'CONTACTER FOURNISSEUR',
    },
    currencyCHF: 'CHF',
    BREADCRUMBS: {
        sortiment:   'CATEGORIE',
        model:       'MODÈLE',
        bathtub:     'BAIGNOIRES',
        wt:          'LAVABOS',
        dwdf:        'RECEVEURS DE DOUCHE',
        showerTrays: 'FONDS DE DOUCHE',
        washbasins:  'LAVABOS',
        urinals:     'URINOIRS',
    },
    showPrices: 'Voir prix',
    hidePrices: 'Couvrir prix',
}



// WEBPACK FOOTER //
// ./src/translations/french.js